import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ShieldCheck } from "lucide-react";

export default function AgeGate() {
  const [open, setOpen] = useState(() => localStorage.getItem("ms_age_confirmed") !== "yes");

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [open]);

  const confirm = () => {
    localStorage.setItem("ms_age_confirmed", "yes");
    setOpen(false);
  };

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          data-testid="age-gate-overlay"
          className="fixed inset-0 z-[100] flex items-center justify-center bg-obsidian/95 backdrop-blur-2xl px-4"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0, transition: { duration: 0.6 } }}
        >
          <motion.div
            className="glass-panel max-w-lg w-full p-8 sm:p-12 text-center"
            initial={{ y: 30, opacity: 0 }}
            animate={{ y: 0, opacity: 1, transition: { delay: 0.2, duration: 0.7 } }}
          >
            <ShieldCheck className="mx-auto text-gold mb-6" size={36} strokeWidth={1.25} />
            <p className="text-xs uppercase tracking-[0.3em] text-gold/80 mb-4">Monroe Society</p>
            <h2 className="font-serif text-3xl sm:text-4xl font-light text-amber-100/95 mb-4">
              This website contains <span className="italic gold-text">adult content</span>
            </h2>
            <p className="text-sm text-neutral-400 font-light leading-relaxed mb-3">
              Monroe Society is a U.S.-based advertising platform for independent adult service providers.
            </p>
            <p className="text-sm text-neutral-400 font-light leading-relaxed mb-8">
              By continuing, you confirm you are over the age of 18, legally permitted to view adult content in your
              jurisdiction, and have read and agreed to our Terms of Service and Privacy Policy.
            </p>
            <div className="flex flex-col sm:flex-row gap-3 justify-center">
              <button
                data-testid="age-gate-enter-button"
                onClick={confirm}
                className="px-8 py-3 bg-gold text-obsidian text-sm uppercase tracking-[0.2em] font-medium hover:bg-gold-bright transition-colors duration-300"
              >
                I am 18 or older — Enter
              </button>
              <a
                data-testid="age-gate-leave-button"
                href="https://www.google.com"
                className="px-8 py-3 border hairline-gold text-neutral-400 text-sm uppercase tracking-[0.2em] hover:text-neutral-200 hover:border-amber-500/40 transition-colors duration-300"
              >
                Leave Site
              </a>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
